import { LegalPage, usePageMeta, Placeholder } from "../components/Legal";
import { BRAND } from "../data/siteData";

const SECTIONS = [
    {
        heading: "Introduction and Scope",
        body: [
            "Eway Fiber Net (“we”, “our”, “us”) is a local FTTH broadband and entertainment service provider serving Narasaraopet, Andhra Pradesh, India. This Privacy Policy explains how we handle personal information when you use our website, our subscriber portal, or our internet, TV and OTT services.",
            "This policy applies to visitors of our website, new-connection enquirers, and active subscribers of Eway Fiber Net.",
        ],
    },
    {
        heading: "Information We Collect",
        body: [
            "We collect information that you voluntarily provide to us — for example when you submit a new-connection enquiry, call or message customer care, register as a subscriber, or make a payment. This typically includes your name, mobile number, installation address or area, chosen plan, and your messages to our team.",
            "When you use our services, we also keep the records needed to operate your connection, such as your plan, billing cycle and service status.",
        ],
    },
    {
        heading: "Subscriber and Account Information",
        body: [
            "When you become a subscriber, we maintain an account record that may include your name, contact details, service address, selected broadband plan, and subscription history. This information is required to activate, manage and renew your connection and to verify your identity when you contact us.",
        ],
    },
    {
        heading: "Contact Information and Customer Support",
        body: [
            "When you contact us by phone, WhatsApp or through our website forms, we use your contact details to respond to your request, resolve faults, and share important service updates such as maintenance notices or renewal reminders.",
        ],
    },
    {
        heading: "Internet Connection, Billing and Payment Information",
        body: [
            "To bill you correctly, we keep records of your plan, billing period, amounts due and payment confirmations. Online bill payments are processed through authorized payment platforms (for example, our official Paytm bill-payment page) or UPI apps.",
            "We do not collect or store your UPI PIN, card numbers, net-banking passwords, OTPs or other payment credentials on our website. Those details are entered only on the secure pages of the payment provider you choose.",
        ],
    },
    {
        heading: "How We Use Customer Information",
        body: [
            "We use personal information to: provide and activate your internet service; manage your subscriber account; process payments and renewals; provide customer support and fault resolution; maintain and improve network operations; prevent fraud and misuse of our network; and comply with applicable laws and lawful requests from authorities.",
            "We do not sell your personal information to advertisers or data brokers.",
        ],
    },
    {
        heading: "Account Security and Authentication",
        body: [
            "Access to our subscriber portal is protected by your login credentials. Please keep your password confidential and inform us promptly if you suspect unauthorized access to your account. We may verify your identity before making changes to your subscription or sharing account details.",
        ],
    },
    {
        heading: "Service Providers and Authorized Third Parties",
        body: [
            "We may share limited information with authorized third parties only where needed to operate our services — for example installation and field-service partners, and payment platforms that process your bill payments. These parties are expected to handle your information only for the service they provide to us.",
            "We may also disclose information where required by applicable law, regulation, or a lawful request from government or law-enforcement authorities.",
        ],
    },
    {
        heading: "Data Retention and Deletion",
        body: [
            "We keep subscriber information for as long as your account is active and for a reasonable period afterwards, as needed for billing records, dispute resolution, and legal or regulatory requirements. You may request deletion of your personal information by contacting customer care; we will honour such requests subject to records we must retain by law.",
        ],
    },
    {
        heading: "Data Security Measures",
        body: [
            "We use reasonable administrative and technical safeguards to protect the information we hold, and access to subscriber records is limited to team members who need it for service operations. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
        ],
    },
    {
        heading: "Cookies and Website Analytics",
        body: [
            "Our website may use basic cookies and privacy-respecting analytics to understand visitor traffic and improve the site experience. You can disable cookies in your browser settings; the website will remain usable, though some preferences may not be remembered.",
        ],
    },
    {
        heading: "Customer Rights and Privacy Requests",
        body: [
            "You may ask us to confirm what personal information we hold about you, correct inaccurate details, or request deletion of your information (subject to legal record-keeping requirements). To make a privacy-related request, contact customer care using the details in the final section of this policy.",
        ],
    },
    {
        heading: "Children's Privacy",
        body: [
            "Our services and website are intended for adults who register and pay for a connection. We do not knowingly collect personal information directly from children. If you believe a child has provided us personal information, please contact us and we will remove it.",
        ],
    },
    {
        heading: "Updates to This Policy",
        body: [
            "We may update this Privacy Policy from time to time. The latest version will always be published on this page with a revised “last updated” date. Continued use of our services after an update means you accept the revised policy.",
        ],
    },
    {
        heading: "Contact Information for Privacy-Related Requests",
        body: [
            <>
                For any privacy question or request, contact Eway Fiber Net customer
                care on{" "}
                <a href={BRAND.phones[0].tel} className="font-semibold text-[#ff6b70] hover:text-white">
                    {BRAND.phones[0].label}
                </a>{" "}
                or{" "}
                <a href={BRAND.phones[1].tel} className="font-semibold text-[#ff6b70] hover:text-white">
                    {BRAND.phones[1].label}
                </a>{" "}
                ({BRAND.careHours}), or visit us in {BRAND.location}.
            </>,
            <>
                Grievance / privacy contact designation:{" "}
                <Placeholder>
                    To be updated — Eway Fiber Net to confirm the official grievance
                    contact name and email before publishing
                </Placeholder>
            </>,
        ],
    },
];

export default function PrivacyPolicy() {
    usePageMeta(
        "Privacy Policy — Eway Fiber Net",
        "How Eway Fiber Net, Narasaraopet's FTTH broadband provider, collects, uses, protects and retains subscriber and website visitor information."
    );
    return (
        <LegalPage
            testId="privacy-policy-page"
            eyebrow="LEGAL & POLICIES"
            title={
                <>
                    Privacy <span className="text-gradient-fire">Policy</span>
                </>
            }
            subtitle="How Eway Fiber Net collects, uses and protects your information as an internet service provider in Narasaraopet, Andhra Pradesh."
            updated="[DATE TO BE CONFIRMED BY EWAY FIBER NET]"
            sections={SECTIONS}
        />
    );
}
